module.exports = __webpack_public_path__ + "img/31.db041e10.svg";